import {UnitSelectionCandidate} from './unit-selection-candidate';
import {PersonLogin} from '../person/person-login';
import {TagInformation} from './tag-information';
import {EntityLineHeader} from '../entity/entity-line-header';

export class ScheduleLineInput {

  scheduleId!: string;
  candidate!: UnitSelectionCandidate;
  user!: PersonLogin;
  quantity!: number;
  tagInformation!: TagInformation[];
  line!: EntityLineHeader;

}
